module.exports = __webpack_public_path__ + "img/envelope1.c8cdb74c.png";